/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ConditionIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Condition',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m27.828 25 4.88-4.879a1 1 0 0 0 0-1.414l-1.415-1.414a1 1 0 0 0-1.414 0L25 22.172l-4.879-4.88a1 1 0 0 0-1.414 0l-1.414 1.415a1 1 0 0 0 0 1.414L22.172 25l-4.88 4.879a1 1 0 0 0 0 1.414l1.415 1.414a1 1 0 0 0 1.414 0L25 27.828l4.879 4.879a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414ZM21.448 3.428 19.8 2.295a1 1 0 0 0-1.39.257L9.684 15.24l-4.657-4.657a1 1 0 0 0-1.414 0L2.2 11.997a1 1 0 0 0 0 1.414l7.207 7.207a1 1 0 0 0 1.53-.14l10.768-15.66a1 1 0 0 0-.257-1.39Z"
    />
  </svg>`;
};
